import { useHistory } from 'react-router-dom';

import { useAuth } from '../hooks/useAuth';
import { BackgroundSVG } from '../components/BackgroundSVG';
import logoCarrano from '../assets/logo.svg';
import googleIconImg from '../assets/google-icon.svg';
import { toast } from 'react-toastify';

import '../styles/main.scss';

export function AuthPage() {
  const history = useHistory();
  const { signInWithGoogle } = useAuth();

  async function handleLoginGoogle() {
    try {
      await signInWithGoogle();
      history.push('/home');
    } catch (error) {
      toast.error('Não foi possível autenticar, tente novamente em instantes!');
    }
  }

  return (
    <>
      <BackgroundSVG />
      <div className="container authpage">
        <div className="logo-container">
          <img src={logoCarrano} alt="CARRANO Logo" />
        </div>
        <h2 className="text-secondary text-regular text-center">SALES</h2>
        <div className="login-container">
          <h2 className="welcome-message">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3.24446 6.07725C3.87186 5.63873 4.81763 5.72283 5.38095 6.18805L4.73486 5.24893C4.21492 4.50738 4.40114 3.70509 5.14334 3.18447C5.88554 2.66585 7.98866 4.06018 7.98866 4.06018C7.46405 3.31128 7.56216 2.36215 8.31104 1.83686C9.05991 1.31356 10.0931 1.49445 10.6177 2.24468L17.5725 12.0697L16.6861 20.6633L9.28884 17.9654L2.83665 8.39869C2.30736 7.64512 2.49024 6.60588 3.24446 6.07725Z"
                fill="#EF9645"
              ></path>
              <path
                d="M1.79877 11.5431C1.79877 11.5431 1.04322 10.4418 2.14517 9.68689C3.24579 8.93199 4.00067 10.0326 4.00067 10.0326L7.50542 15.1441C7.62623 14.9425 7.75838 14.7436 7.90589 14.5474L3.04155 7.45423C3.04155 7.45423 2.28667 6.35358 3.38795 5.59868C4.48857 4.84378 5.24345 5.94442 5.24345 5.94442L9.81879 12.6171C9.98899 12.4782 10.1632 12.3387 10.3427 12.2019L5.03854 4.46532C5.03854 4.46532 4.28366 3.36468 5.38495 2.60978C6.48557 1.85488 7.24045 2.95552 7.24045 2.95552L12.5446 10.6908C12.7395 10.5713 12.9324 10.4678 13.126 10.3584L8.16819 3.1284C8.16819 3.1284 7.41331 2.02775 8.51393 1.27285C9.61455 0.517946 10.3694 1.61859 10.3694 1.61859L15.6115 9.26372L16.4085 10.4264C13.106 12.6918 12.7916 16.9536 14.6785 19.7055C15.0556 20.2562 15.6062 19.8791 15.6062 19.8791C13.3416 16.5758 14.033 12.864 17.3362 10.5993L16.3624 5.7255C16.3624 5.7255 15.9987 4.4413 17.2822 4.07686C18.5663 3.71309 18.9307 4.99729 18.9307 4.99729L20.0554 8.33728C20.5012 9.66153 20.9758 10.9811 21.6039 12.2293C23.3773 15.7535 22.318 20.1334 18.9741 22.4274C15.3265 24.9284 10.3401 23.9986 7.83848 20.3516L1.79877 11.5431Z"
                fill="#FFDC5D"
              ></path>
              <path
                d="M8.00934 21.3517C5.33956 21.3517 2.64175 18.657 2.64175 15.9903C2.64175 15.6216 2.37143 15.3236 2.00233 15.3236C1.63324 15.3236 1.30685 15.6216 1.30685 15.9903C1.30685 19.9903 4.00467 22.685 8.00934 22.685C8.37844 22.685 8.67679 22.359 8.67679 21.9904C8.67679 21.6217 8.37844 21.3517 8.00934 21.3517Z"
                fill="#121212"
              ></path>
              <path
                d="M4.67212 22.6651C2.66978 22.6651 1.33489 21.3301 1.33489 19.3278C1.33489 18.9587 1.03654 18.6603 0.667445 18.6603C0.298348 18.6603 0 18.9587 0 19.3278C0 21.9976 2.00234 24 4.67212 24C5.04122 24 5.33956 23.7016 5.33956 23.3325C5.33956 22.9634 5.04122 22.6651 4.67212 22.6651ZM16.0187 1.30627C15.6503 1.30627 15.3512 1.6053 15.3512 1.97374C15.3512 2.34218 15.6503 2.6412 16.0187 2.6412C18.6885 2.6412 21.3583 5.03672 21.3583 7.9809C21.3583 8.34934 21.6573 8.64836 22.0257 8.64836C22.3941 8.64836 22.6931 8.34934 22.6931 7.9809C22.6931 4.30051 20.0234 1.30627 16.0187 1.30627Z"
                fill="#121212"
              ></path>
              <path
                d="M19.3559 0C18.9875 0 18.6885 0.270674 18.6885 0.638684C18.6885 1.00669 18.9875 1.33337 19.3559 1.33337C21.3583 1.33337 22.6651 2.81674 22.6651 4.63879C22.6651 5.0068 22.9915 5.30548 23.3606 5.30548C23.7297 5.30548 24 5.0068 24 4.63879C24 2.08072 22.0257 0 19.3559 0Z"
                fill="#121212"
              ></path>
            </svg>{' '}
            Bem vindo de volta, vendedor!
          </h2>
          <h3>Para entrar em nosso sistema, entre com a sua conta Google clicando no botão abaixo.</h3>

          <div className="input-box-auth">
            <div className="wrapper-button">
              <button onClick={handleLoginGoogle} className="google-button">
                <img src={googleIconImg} alt="" />
                Faça login com o google
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
